const metaNavFlyoutButtons = document.querySelectorAll('[data-hasSidebar="true"]');
const metaNavFlyout = document.getElementById('sidebar');
const metaNavFlyoutContent = document.getElementById('sidebar-content');
const metaNavFlyoutClose = document.getElementById('sidebar-close');
const metaNavFlyoutContentItems = document.getElementsByClassName('selection__content');

Array.from(metaNavFlyoutButtons).forEach(item => {
    item.addEventListener('click', (e) => {
        const contentSelector = `[data-contentId="${e.target.dataset.target}"]`;
        metaNavFlyout.classList.add('sidebar-container--visible');
        metaNavFlyoutContent.classList.add('sidebar-selection--visible');
        document.querySelector(contentSelector).classList.add('selection__content--visible');
    });
});

metaNavFlyoutClose.addEventListener('click', () => {
    Array.from(metaNavFlyoutContentItems).forEach(item => {
        item.classList.remove('selection__content--visible');
    });
    metaNavFlyout.classList.remove('sidebar-container--visible');
    metaNavFlyoutContent.classList.remove('sidebar-selection--visible');
});



// WEBPACK FOOTER //
// ./src/scripts/components/meta-nav/index.js